/* HoutjeWarm — keuzehulp banner positionering naast collectietitel (desktop) */
(function () {
  function positionKeuzehulpBanner(overlayId) {
    if (window.innerWidth < 769) return;
    var cta = document.querySelector('.keuzehulp-cta');
    if (!cta) return;
    var mySection = cta.closest('.shopify-section');
    if (!mySection) return;

    var sibling = mySection.previousElementSibling;
    var targetGrid = null;
    while (sibling) {
      var g = sibling.querySelector('.row.grid');
      if (g && g.querySelector('.columns')) { targetGrid = g; break; }
      sibling = sibling.previousElementSibling;
    }
    if (!targetGrid) { cta.style.visibility = 'visible'; return; }

    var overlay = overlayId ? document.getElementById(overlayId) : null;
    if (overlay) document.body.appendChild(overlay);

    targetGrid.style.cssText += ';display:flex;align-items:flex-start;flex-wrap:nowrap;';
    Array.from(targetGrid.children).forEach(function (col) {
      col.style.flex = '1 1 auto';
      col.style.minWidth = '0';
      col.style.paddingRight = '40px';
    });

    var rightCol = document.createElement('div');
    rightCol.style.cssText = 'flex:0 0 auto;display:flex;align-items:flex-start;';
    cta.style.margin = '0';
    cta.style.visibility = 'visible';
    rightCol.appendChild(cta);
    targetGrid.appendChild(rightCol);

    mySection.style.display = 'none';
  }

  window.hjwPositionBanner = positionKeuzehulpBanner;
})();
